module.exports = __webpack_public_path__ + "static/media/washington_commun.7e06e589.jpg";